import { Badge, Group } from '@mantine/core';
import type { AdminUserRow } from '../hooks/useUsers';

export function UserBadges({ row }: { row: AdminUserRow }) {
  return (
    <Group gap={4}>
      {row.is_sim && (
        <Badge size="xs" color="grape" variant="light">
          sim
        </Badge>
      )}
      {/* Admins may also be mentees — dogfooding with a real account is worth more
          than identity hygiene at this size, but the row says so out loud. */}
      {row.is_admin && (
        <Badge size="xs" color="blue" variant="light">
          admin
        </Badge>
      )}
      {row.deleted_at && (
        <Badge size="xs" color="red" variant="light">
          deleted
        </Badge>
      )}
      {!row.has_completed_onboarding && (
        <Badge size="xs" color="yellow" variant="light">
          onboarding incomplete
        </Badge>
      )}
    </Group>
  );
}
